import ContestInfoContainer from "./contest-info-container.tsx";

interface Props {
  entryFee: number,
}

const EntryFeeDisplay = ({ entryFee }: Props) => {
  const topText = entryFee && entryFee > 0 ? "$" + entryFee : "Free"
  const bottomText = "Entry"

  return (
    <div style={{ width: 50, textAlign: "center" }}>
      <ContestInfoContainer topText={topText} bottomText={bottomText} />
    </div>
  )
}

export default EntryFeeDisplay;